import { isMobileNative } from 'app/utils/web-helpers';
import { type RefObject, useEffect, useEffectEvent } from 'react';

const noop = () => undefined;

export function useClickOutside(refs: RefObject<HTMLElement | null>[], callback: (_: boolean) => void = noop): void {
  const handleClickOutside = useEffectEvent((event: MouseEvent) => {
    const clickedOutside = refs.every((ref) => {
      return ref.current && !ref.current.contains(event.target as Node);
    });

    callback(clickedOutside);
  });

  useEffect(() => {
    if (isMobileNative) return;

    document.addEventListener('pointerdown', handleClickOutside);
    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, []);
}
